import Icon from '../components/Icon.vue'

Icon.register({
  'angle-double-down': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M143 256.3l-136-136c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.8 22.5c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 0.1zM177 448.3c-9.4 9.4-24.6 9.4-34-0.1l-136-136c-9.4-9.3-9.4-24.5 0-33.9l22.7-22.6c9.3-9.4 24.5-9.4 33.9 0l96.4 96.4 96.5-96.3c9.3-9.4 24.5-9.4 33.9 0l22.6 22.6c9.4 9.3 9.4 24.5 0 33.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angle-double-down.js
// module id = 602
// module chunks = 0